import { styled } from '@mui/material';

export const Count = styled('span')(({ theme }) => ({
  ...theme.typography.overline,
  position: 'relative',
  color: theme.palette.text.secondary,
  marginLeft: 10,
  marginRight: 10,

  '&::before': {
    content: '""',
    position: 'absolute',
    display: 'block',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.grey[300],
    borderRadius: 12,
    top: -5,
    left: -10,
    right: -10,
    bottom: -5,
  },
}));
